import { preventMinification } from './preventMinification';
import { useUserStore } from '@/stores/userStore';

/**
 * Retrieves the API key for Faro analytics.
 * Priority:
 *   1. Use public API key from environment if available.
 *   2. Otherwise, fetch user and use their access token.
 */
export async function getFaroApiKey(): Promise<string> {
  const publicApiKey = preventMinification(import.meta.env.VITE_FARO_PUBLIC_API_KEY);
  if (publicApiKey) {
    return publicApiKey;
  }
  const user = useUserStore();
  if (!user.user) {
    await user.fetch();
  }
  return user.user?.access_token || '';
}
